module.exports = __webpack_public_path__ + "img/buducnost-logo-icon.6f06ccf7.png";